// Roles
export const ADMIN_ROLE = 'ADMIN';

export const THEATER_ADMIN_ROLE = 'THEATER_ADMIN';

export const ARTIST_ROLE = 'ARTIST';

export const USER_ROLE = 'USER';

// Plans
export const FREE_PLAN = 'free';

export const PRODUCERS_PLAN = 'two';

export const VENUES_PLAN = 'three';

export const FULL_PLAN = 'four';

// Professions

export const SINGER = 'singer';

export const DANCER = 'dancer';

export const MUSICIAN = 'musician';

// export const ARTIST = 'artist';

export const REGISSEUR = 'regisseur';

export const COSTUME = 'costume';

export const LIGHTING = 'lighting';

export const COMPOSER = 'composer';

export const CONDUCTOR = 'conductor';

export const MAKEUP = 'makeup';

export const STAGE_DESIGNER = 'stage_designer';

export const CHOREOGRAPHER = 'choreographer';

export const MANAGER = 'manager';

export const MULTIMEDIA = 'multimedia';

// Specialties


export const getSpecialties = (profession) => {
  switch (profession) {
    case SINGER:
      return [
        {
          value: 'Cantante lieder / lieder singer',
          label: 'Cantante lieder / lieder singer',
        },
        { value: 'Soprano', label: 'Soprano' },
        {
          value: 'Soprano lírica ligera (coloratura)',
          label: 'Soprano lírica ligera (coloratura)',
        },
        { value: 'Soprano lírica', label: 'Soprano lírica' },
        { value: 'Soprano dramática', label: 'Soprano dramática' },
        { value: 'Mezzo-Soprano', label: 'Mezzo-Soprano' },
        { value: 'Mezzo-Soprano lírica', label: 'Mezzo-Soprano lírica' },
        { value: 'Mezzo-Soprano dramática', label: 'Mezzo-Soprano dramática' },
        {
          value: 'Contra-Tenor / Counter Tenor',
          label: 'Contra-Tenor / Counter Tenor',
        },
        { value: 'Tenor', label: 'Tenor' },
        { value: 'Tenor Lírico ligero', label: 'Tenor Lírico ligero' },
        { value: 'Tenor lírico ', label: 'Tenor lírico ' },
        { value: 'Tenor Lírico - spintto ', label: 'Tenor Lírico - spintto ' },
        { value: 'Tenor dramático', label: 'Tenor dramático' },
        { value: 'Baritono', label: 'Baritono' },
        { value: 'Baritono lírico', label: 'Baritono lírico' },
        { value: 'Baritono dramático', label: 'Baritono dramático' },
        { value: 'Bajo-Barítono', label: 'Bajo-Barítono' },
        { value: 'Bajo ', label: 'Bajo ' },
        { value: 'Bajo cantante', label: 'Bajo cantante' },
        { value: 'Bajo profundo', label: 'Bajo profundo' },
        { value: 'Contralto', label: 'Contralto' },
        { value: 'Cantante de carácter', label: 'Cantante de carácter' },
      ];
    case DANCER:
      return [
        { value: 'Clásico', label: 'Clásico' },
        { value: 'Contemporaneo', label: 'Contemporaneo' },
        { value: 'De caracter', label: 'De caracter' },
      ];
    case MUSICIAN:
      return [
        { value: 'Piano', label: 'Piano' },
        { value: 'Violin ', label: 'Violin ' },
        { value: 'Viola', label: 'Viola' },
        { value: 'Cello', label: 'Cello' },
        { value: 'Contrabajo', label: 'Contrabajo' },
        { value: 'Flauta', label: 'Flauta' },
        { value: 'Clarinete', label: 'Clarinete' },
        { value: 'Oboe', label: 'Oboe' },
        { value: 'Fagot', label: 'Fagot' },
        { value: 'Corno Inglés', label: 'Corno Inglés' },
        { value: 'Corno Francés', label: 'Corno Francés' },
        { value: 'Trompeta', label: 'Trompeta' },
        { value: 'Corno', label: 'Corno' },
        { value: 'Repetidor', label: 'Repetidor' },
        { value: 'Trombon', label: 'Trombon' },
        { value: 'Tuba', label: 'Tuba' },
        { value: 'Guitarra', label: 'Guitarra' },
        { value: 'Percusión', label: 'Percusión' },
        { value: 'Arpa', label: 'Arpa' },
        { value: 'Otro', label: 'Otro' },
      ];
    default:
      return [];
  }
};

export const getFilterableProfessions = () => [
  // 1. Cantantes / Singer
  {
    id: 1,
    profession: SINGER,
    specialty: '',
    label: 'Cantantes / Singer',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/opera.jpeg',
  },
  // 2. Músicos / Musician
  {
    id: 2,
    profession: MUSICIAN,
    specialty: '',
    label: 'Músicos / Musician',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/orquesta-min.jpeg',
  },
  // 3. Bailarines / Dancer
  {
    id: 3,
    profession: DANCER,
    specialty: '',
    label: 'Bailarines / Dancer',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/bailarina-min.jpeg',
  },
  // 4. Director Orquesta / Music Director
  {
    id: 4,
    profession: CONDUCTOR,
    specialty: '',
    label: 'Director orquesta / conductor',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/director-min.jpeg',
  },
  // 5. Director Escena / Stage Director
  {
    id: 5,
    profession: REGISSEUR,
    specialty: '',
    label: 'Regisseur / Stage Director',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/silla-min.jpeg',
  },
  // 6. Compositor / Composer
  {
    id: 6,
    profession: COMPOSER,
    specialty: '',
    label: 'Compositor / Composer',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/pentagrama-min.jpeg',
  },
  // 7. Coreógrafo / Choreographer
  {
    id: 7,
    profession: CHOREOGRAPHER,
    specialty: '',
    label: 'Coreografo / choreographer',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/coreog.jpeg',
  },
  // 8. Diseñador Luces / Light Designer
  {
    id: 8,
    profession: LIGHTING,
    specialty: '',
    label: 'Iluminación / Lighting designer',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/luces-min.jpeg',
  },
  // 9. Diseñador Vestuario / Costume Designer
  {
    id: 9,
    profession: COSTUME,
    specialty: '',
    label: 'Vestuarista / costume designer',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/modisto-min.jpeg',
  },
  // 10. Escenógrafo / Stage Designer
  {
    id: 10,
    profession: STAGE_DESIGNER,
    specialty: '',
    label: 'Escenógrafo / Stage Designer',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/escenografo-min.jpeg',
  },
  // 11. Diseñador Multimedia / Multimedia Designer
  {
    id: 11,
    profession: MULTIMEDIA,
    specialty: '',
    label: 'Multimedia / Audiovisual',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/audiovisual-min+.jpeg',
  },
  // 12. Maquillador / Makeup artist
  {
    id: 12,
    profession: MAKEUP,
    specialty: '',
    label: 'Maquillador / Makeup artist',
    pictureUrl: 'https://escena.s3-sa-east-1.amazonaws.com/maquillaje-min.jpeg',
  },
];



// WEBPACK FOOTER //
// ./src/constants.js